import MyApp from '../src/pages/_app';

export default MyApp;
